import { useEffect, useState } from 'react';
import styles from '../../../styles/modules/Registration.module.css';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import { useSelector } from 'react-redux';
import CustomCheckbox from '../../CustomComponents/CustomCheckbox/CustomCheckbox';
import { BiDollar } from "react-icons/bi";
import CustomContainerLoader from '../../CustomComponents/CustomContainerLoader/CustomContainerLoader';
import { TextField } from '@mui/material';

const FormFeeDetails = ({ formTemplateId, feeDetails, setFeeDetails }) => {
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const [participantFeeList, setParticipantFeeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getAllParticipantFee = async () => {
    try {
      setIsLoading(true);
      const response = await FormTemplateAPI.getAllSelectedParticipantFee(formTemplateId);
      setParticipantFeeList(response.Data)
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleOnChange = (participantFee, val) => {
    setFeeDetails((prev) => {
      let newList = [...prev];
      if (val && !newList.some(item => item.id === participantFee.id)) {
        newList.push(participantFee);
      } else {
        newList = newList.filter(item => item.id !== participantFee.id)
      }
      return newList;
    })
    //console.log(feeDetails);

  };

  useEffect(() => {
    if (selectedClub.clubId) {
      getAllParticipantFee();
    }
  }, [selectedClub.clubId]);


  if (isLoading) {
    return <CustomContainerLoader />
  }

  return (
    <div className={styles['form_fee_details_con']}>
      <h2>Select Participation Fee category</h2>
      <div className={styles['form_fee_list']}>
        {participantFeeList?.map((p, idx) =>
          <div key={idx} className={styles['form_fee_card']}>
            <CustomCheckbox checked={feeDetails?.some(item => item.id === p.id)} onChange={(event) => handleOnChange(p, event.target.checked)} />
            <div className={styles['form_fee_list_text']}>
              <h3>{p?.criteria}</h3>
              <p>{p?.description}</p>
            </div>
            {
              !p?.isCustomAmount
                ? <h3 className={styles['form_fee_list_price']}><BiDollar className={styles['form_fee_list_price_icon']} />{Number(p?.feeAmount).toFixed(2)}</h3>
                :
                <TextField
                  size='small'
                  type='number'
                  sx={{ width: 100 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFeeDetails(prev =>
                      prev.map(item =>
                        item.id === p.id ? { ...item, feeAmount: value } : item
                      )
                    );
                  }}

                  name='amount'
                  className='calender-setting-text-input'
                  variant='outlined'
                  label='Amount' />}
          </div>)}
      </div>
    </div>
  )
}

export default FormFeeDetails